<template>
    <!-- Основной контейнер -->
    <MainLayout>
        <!-- Компонент оплаты -->
        <PayComponent 
            :payment-amount="paymentAmount"
            :selected-size="selectedSize"
            :product-name="productName"
            :product-photo="productPhoto"

            :is-drop="isDrop"
            :delivery-service="deliveryService" 
            :order-number="orderNumber"
            :track-number="trackNumber" 
            :baracode-photo="baracodePhoto"
            :order-link="orderLink"
            :is-from-abroad="isFromAbroad"
            :batch-id="batchId"
        />
    </MainLayout>
        
    
</template>

<script>
import MainLayout from "@/components/MainLayout.vue";
import PayComponent from "@/components/PayComponent.vue";
export default {
    components: {
        MainLayout,
        PayComponent
    },
    props: {
        paymentAmount: {
            type: Number,
            required: true
        },
        selectedSize: {
            type: String,
            required: true,
        },
        productName: {
            type: String,
            required: true,
        },
        productPhoto: {
            type: String,
            required: true,
        },

        // Указывает, является ли заказ дропом
        isDrop: {
            type: Boolean,
            required: false,
        },

        // Дроповые данные (необязательные)
        deliveryService: {
            type: String,
            required: false,
        },
        orderNumber: {
            type: String,
            required: false,
        },
        trackNumber: {
            type: String,
            required: false,
        },
        baracodePhoto: {
            type: String,
            required: false,
        },
        orderLink: {
            type: String,
            required: false,
        },
        isFromAbroad: {
            type: Boolean,
            required: false,
        },
        batchId: {
            type: [Number, String],
            default: null,
        },

    },
}

</script>

<style>

</style>